import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { IApiBackendRouteService } from '../abstract/api-routes.service';
import { API_BASE_URL } from '../../../core/providers/constants/api.constants';
import { InspectionAssemblyItem } from '../types/inspection-assembly-item';
import { Inspection } from '../types/inspections';
import { InspectionApiDto } from '../dto/inspection.dto';
import { InspectionVisualRecords } from '../types/inspection-visual';
import { TrimmingInspectionPayload } from 'src/app/views/scheduler-stage/interfaces/trimming-inspection.interface';
import { InspectionTrimmingSpec } from '../types/inspection-specs';
import { TrimmingInspectionResponse } from '../types/trimming-inspection-response';
import { Stage } from '../types/stages';

@Injectable({
  providedIn: 'root',
})
export class ApiRouteInspectionService extends IApiBackendRouteService {
  urlRoute = `${API_BASE_URL}/inspection`;

  constructor(protected readonly http: HttpClient) {
    super();
  }

  createInspection(
    body: InspectionApiDto['create']['body']
  ): Observable<InspectionApiDto['create']['result']> {
    return this.http.post<InspectionApiDto['create']['result']>(
      `${this.urlRoute}`,
      body
    );
  }

  getInspectionById(id: number): Observable<Inspection> {
    return this.http.get<Inspection>(`${this.urlRoute}/${id}`);
  }

  checkForOpenInspection(
    itemIdForInspection: number,
    options: InspectionApiDto['open']['query'] = {}
  ): Observable<Inspection | undefined> {
    let params = new HttpParams();
    if (options.fromStage) {
      params = params.set('fromStage', options.fromStage);
    }
    return this.http.get<Inspection | undefined>(
      `${this.urlRoute}/available/${itemIdForInspection}`,
      {
        params,
      }
    );
  }

  validateInspectionByShift(body: {
    workOrderId: number;
    machineId: number;
  }): Observable<{ openInspection: Inspection; measureStage: Stage }> {
    return this.http.post<{ openInspection: Inspection; measureStage: Stage }>(
      `${this.urlRoute}/validate-from-shift`,
      {
        ...body,
      }
    );
  }

  // uploadChangesOfDimensionInspection(data: any): Observable<any> {
  //   return this.http.patch(`${this.urlRoute}/measurements`, {
  //     data,
  //   });
  // }

  finishInspection(
    inspectionId: number,
    notes: string | undefined,
    body: InspectionApiDto['finish']['body'] = {}
  ): Observable<InspectionApiDto['finish']['result']> {
    return this.http.post<InspectionApiDto['finish']['result']>(
      `${this.urlRoute}/finish/${inspectionId}`,
      {
        ...body,
        notes,
      }
    );
  }

  // finishPartialInspection(
  //   inspectionId: number,
  //   body: InspectionApiDto['finishPartial']['body']
  // ): Observable<boolean> {
  //   return this.http.post<boolean>(
  //     `${this.urlRoute}/finish-partial/${inspectionId}`,
  //     body
  //   );
  // }

  removeInspection(inspectionId: number): Observable<boolean> {
    return this.http.delete<boolean>(`${this.urlRoute}/${inspectionId}`);
  }

  deleteNewestVisual(
    inspectionId: number
  ): Observable<InspectionVisualRecords> {
    return this.http.delete<InspectionVisualRecords>(
      `${this.urlRoute}/${inspectionId}/visual/latest`
    );
  }

  editInspection(
    inspectionId: number,
    body: Partial<Inspection>
  ): Observable<boolean> {
    return this.http.patch<boolean>(`${this.urlRoute}/${inspectionId}`, body);
  }

  getInspectionMeasurementData(
    itemName: string
  ): Observable<InspectionAssemblyItem> {
    return this.http.get<InspectionAssemblyItem>(
      `${this.urlRoute}/sheet?itemName=${itemName}`
    );
  }

  reject(
    body: InspectionApiDto['reject']['body']
  ): Observable<InspectionApiDto['reject']['result']> {
    return this.http.post<InspectionApiDto['reject']['result']>(
      `${this.urlRoute}/rejection`,
      body
    );
  }

  getInspectionMachine(
    data: InspectionApiDto[`machine`]
  ): Observable<Inspection> {
    return this.http.post<Inspection>(`${this.urlRoute}/item-machine`, {
      ...data,
    });
  }

  getByDepartment(department: string): Observable<Inspection[]> {
    return this.http.get<Inspection[]>(
      `${this.urlRoute}/by-department?department=${department}`
    );
  }

  saveTrimmingInspection(
    payload: TrimmingInspectionPayload
  ): Observable<TrimmingInspectionResponse> {
    return this.http.post<TrimmingInspectionResponse>(
      `${this.urlRoute}/trimming-register`,
      payload
    );
  }

  getTrimmingSpecs(
    workOrder: string | number
  ): Observable<InspectionTrimmingSpec[]> {
    return this.http.get<InspectionTrimmingSpec[]>(
      `${this.urlRoute}/trimming-specs/${workOrder}`
    );
  }

  reviewPendingStatus(
    inspectionId: number,
    supervisorId: number,
    decision: 'approve' | 'reject'
  ): Observable<{ status: string; passed: boolean }> {
    return this.http.post<{ status: string; passed: boolean }>(
      `${this.urlRoute}/review-pending`,
      { inspectionId, supervisorId, decision }
    );
  }
}
